var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',_vm._l((_vm.rows),function(row,index){return _c('b-row',{key:index},_vm._l((row),function(image){return _c('b-col',{key:image.image_id},[_vm._v(_vm._s(image.image_name))])}),1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }